import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
// import MenuItem from '@material-ui/core/MenuItem';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import {
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButtonShop from '../../components/atoms/CancelButtonShop';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiChildFoodListAddConfirmShop from './GochiChildFoodListAddConfirmShop';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import {
  getGochiChildFoodLists,
  addGochiChildFoodList,
  addGochiChildFoodListImage,
  getChildFoodGroups,
  getChildFoodShops
} from '../../actions/GochiChildFoodLists';
import { getAccounts } from '../../actions/Accounts';
// import { getShops } from '../../actions/Shop';
// import { getGroups } from '../../actions/Groups';
import ValidationText from '../../components/atoms/ValidationText';
import { languages, languageType } from '../../constants/Language';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 20
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px',
    width: '100%'
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  listForm: {
    display: 'block'
  },
  itemForm: {
    display: 'block',
    padding: '20px 20px 12px',
    borderBottom: '1px solid #DDDDDD'
  },
  textExplain: {
    fontSize: 12
  },
  btnBtom: {
    padding: '0 12px 10px 12px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.list,
      groups: state.groups.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getChildFoodShops,
          getChildFoodGroups,
          getAccounts,
          getGochiChildFoodLists,
          addGochiChildFoodList,
          addGochiChildFoodListImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('groupName', 'setGroupName', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('childFoodName', 'setChildFoodName', ''),
  withState('childFoodNameError', 'setChildFoodNameError', ''),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('childFoodImage', 'setChildFoodImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      let dataFirst = {};
      const origilData = {
        shopName: null,
        groupName: null,
        childFoodName: null,
        childFoodDescription: null,
        previewImage: null,
        shopId: null,
        groupId: null
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
      console.log('dataFirst', dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    openAddChildFoodConfirm,
    updateOpenAddChildFood,
    updateOpenAddChildFoodConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    account,
    shopId,
    setShopId,
    groupId,
    setGroupId,
    shopName,
    setShopName,
    shops,
    groupName,
    setGroupName,
    groups,
    childFoodName,
    setChildFoodName,
    childFoodDescription,
    setChildFoodDescription,
    childFoodImage,
    setChildFoodImage,
    previewImage,
    setPreviewImage,
    shopNameError,
    setShopNameError,
    groupNameError,
    setGroupNameError,
    childFoodNameError,
    setChildFoodNameError,
    handleChangePageChildFood,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType
  }) => {
    console.log('groupId', groupId);
    const isCreateChildFoodShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);

    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';

    const errors = {
      shopNameError,
      groupNameError,
      childFoodNameError
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        shopName,
        groupName,
        childFoodName,
        childFoodDescription,
        previewImage,
        shopId,
        groupId
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          childFoodName,
          childFoodDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          console.log('multiLangData', multiLangData);
          if (multiLangData.otherLanguages[k].language === v) {
            setChildFoodName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.childFoodName
                ? multiLangData.otherLanguages[k].params.childFoodName
                : ''
            );
            setChildFoodDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.childFoodDescription
                ? multiLangData.otherLanguages[k].params.childFoodDescription
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setChildFoodName(multiLangData.childFoodName);
        setChildFoodDescription(multiLangData.childFoodDescription);
      }
      setIsLanguage(v);
      setMultiLangData(data);
      console.log('loc', data);
    };

    const validShopName = () => {
      const value = shopId;
      if (value === 0) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopId(value);
      return 0;
    };
    const validGroupName = () => {
      const value = groupId;
      if (value === 0) {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupId(value);
      return 0;
    };
    const validChildFoodName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = childFoodName;
      if (value.trim() === '') {
        setChildFoodNameError('必須項目です。');
        return 1;
      }
      setChildFoodNameError('');
      setChildFoodName(value);
      return 0;
    };

    const valid = () => {
      const errorCount =
        validShopName() + validChildFoodName() + validGroupName();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const setShopNameData = id => {
      shops.forEach(item => {
        if (id === item.shopId) {
          setShopName(item.shopName);
        }
      });
    };
    const setGroupNameData = id => {
      groups.forEach(item => {
        if (id === item.groupId) {
          setGroupName(item.groupName);
        }
      });
    };

    const cancelAction = () => {
      updateOpenAddChildFood(false);
      setShopId(0);
      setGroupId(-1);
    };
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setShopNameData(shopId);
        setGroupNameData(groupId);
        setMultiLangData(getCurrentData());
        updateOpenAddChildFoodConfirm(true);
      }
    };
    const backAction = () => updateOpenAddChildFoodConfirm(false);
    const registerAction = async () => {
      updateLoading(true);
      updateOpenAddProgress(true);
      const addedChildFoodList = await actions
        .addGochiChildFoodList({ ...multiLangData, previewImage: null })
        .then(data => checkSession(data));
      if (childFoodImage !== null) {
        let imageData = childFoodImage;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'child_food',
          addedChildFoodList.payload.childFoodId,
          imageData,
          'public'
        );
        actions
          .addGochiChildFoodListImage(addedChildFoodList.payload.childFoodId, {
            images: [
              {
                image: imagePath
              }
            ]
          })
          .then(data => checkSession(data));
      }
      if (addedChildFoodList.type === 'ADD_GOCHI_CHILD_FOOD_SUCCESS') {
        updateIsAddSuccess(true);
        actions
          .getGochiChildFoodLists(searchKey)
          .then(data => checkSession(data));
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAddChildFood(false);
        updateOpenAddChildFoodConfirm(false);
        updateOpenAddProgress(false);
        handleChangePageChildFood(null, 1, 10);
      } else {
        updateOpenAddProgress(false);
      }
    };

    const getGroupOptions = () => {
      const groupOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (isSecretariat) {
        if (!shopId || shopId === 0) {
          groups
            .filter(item => item.groupType.toUpperCase() === 'OTHERS')
            .forEach(group => {
              groupOptions.push({
                label: group.groupName,
                value: String(group.groupId)
              });
            });
        } else {
          groups
            .filter(
              item =>
                item.groupType.toUpperCase() === 'OTHERS' &&
                item.shopIds &&
                item.shopIds.includes(shopId)
            )
            .forEach(group => {
              groupOptions.push({
                label: group.groupName,
                value: String(group.groupId)
              });
            });
        }
      }
      if (isCreateChildFoodShop) {
        console.log('groups', groups);
        groups
          .filter(item => account.belongToChildGroups.includes(item.groupId))
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }
      return { ...groupOptions, tmpObj };
    };

    const getShopOptions = () => {
      const shopOptions = [];
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId)
        });
      });
      return shopOptions;
    };

    const selectShopOption = v => {
      setGroupId(Number(0));
      setShopId(Number(v));
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">こども食堂メニュー情報登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <List component="nav" className={classes.listForm}>
            {
              <>
                <ListItem className={classes.itemForm}>
                  <Select
                    className={classes.textField}
                    value={isLanguage}
                    onChange={e => {
                      if (isLanguage === e.target.value) {
                        return;
                      }
                      if (
                        valid() ||
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0)
                      ) {
                        setLanguage(e.target.value);
                      } else {
                        alert('登録情報を正しく入力してください。');
                      }
                    }}
                  >
                    {languages.map(lang => (
                      <MenuItem key={lang.value} value={lang.value}>
                        {lang.label}
                      </MenuItem>
                    ))}
                  </Select>
                </ListItem>
                {isLanguage !== languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography component="div" className={classes.formInput}>
                      <RadioGroup
                        value={translateType}
                        onChange={e => {
                          console.log('e', e.target.value);
                          setTranslateType(parseInt(e.target.value, 10));
                        }}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="GG翻訳を選択"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="自分で文章入力"
                        />
                      </RadioGroup>
                    </Typography>
                  </ListItem>
                )}
              </>
            }
            {isLanguage === languageType.ORIGIN && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <ReactSelectMaterialUi
                    required
                    label="店舗名*"
                    className={classes.textField}
                    defaultValue={String(shopId)}
                    options={getShopOptions()}
                    margin="normal"
                    onChange={v => {
                      selectShopOption(v);
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validShopName}
                  />
                  <ValidationText message={errors.shopNameError} />
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && shopId > 0 && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <ReactSelectMaterialUi
                    required
                    label="グループ名*"
                    className={classes.textField}
                    defaultValue={String(groupId)}
                    value={String(groupId)}
                    options={getGroupOptions()}
                    margin="normal"
                    onChange={z => {
                      setGroupId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validGroupName}
                  />
                  <ValidationText message={errors.groupNameError} />
                </Typography>
              </ListItem>
            )}
            {isLanguage === languageType.ORIGIN && (!shopId || shopId <= 0) && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <ReactSelectMaterialUi
                    disabled
                    required
                    label="グループ名*"
                    className={classes.textField}
                    defaultValue={String(groupId)}
                    // value={String(groupId)}
                    options={getGroupOptions()}
                    margin="normal"
                    onChange={z => {
                      setGroupId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validGroupName}
                  />
                  <ValidationText message={errors.groupNameError} />
                </Typography>
              </ListItem>
            )}

            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <RequiredButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  required
                  label="メニュー名"
                  className={classes.textField}
                  margin="normal"
                  value={childFoodName}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  onChange={e => {
                    setChildFoodName(e.target.value);
                  }}
                  onBlur={validChildFoodName}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                  }}
                />
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.childFoodNameError} />
                )}
              </Typography>
            </ListItem>
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <AnyButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  className={classes.textFieldLong}
                  margin="normal"
                  value={childFoodDescription}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 1000 : 2500
                  }}
                  onChange={e => {
                    setChildFoodDescription(e.target.value);
                  }}
                />
              </Typography>
            </ListItem>
            {isLanguage === languageType.ORIGIN && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <AnyButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <FileUpload
                    label="image"
                    setFile={setChildFoodImage}
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                  />

                  <div className={classes.textExplain}>
                    ※8MB以内でお願いします。
                  </div>
                </Typography>
              </ListItem>
            )}
          </List>
        </Paper>
        <div className={classes.btnBtom}>
          <CancelButtonShop onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddChildFoodConfirm} className={classes.modalMobile}>
          <GochiChildFoodListAddConfirmShop
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            openAddProgress={openAddProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            shopName={shopName}
            groupName={groupName}
            currentLanguage={isLanguage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
